import services from './../services/service'; // Service Class
let service = new services();

export default {
    name: 'Preset',
    data () {
      return {
        active_logged_in:false,
        user:{},
      }
  },

    methods: {
        preset() { //recheck do login ifelse
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.active_logged_in = true;
                    self.user.user_id = value.user_id;
                    self.user.user_name = value.user_name;
                }else {
                   /// self.$router.push('login');
                }
            });
        },
     
    },
    created: function(){
        this.preset();
    }
}


// WEBPACK FOOTER //
// ./src/resources/preset.js